<template>
  <div>
    <div class="menu">
      <div :class="activeMenu== item.id?'activeMenu':''"
           @click="menuBar(item.id)"
           v-for="item in menuList"
           :key="item.id">
        <span>{{ item.name }}</span>
        <i class="activeIcon"></i>
      </div>
    </div>
  </div>
</template>
<script>
//   import bus from '../bus/index'
export default {
  data() {
    return {
      activeMenu: 1,
      menuList: [
        {name: "最新", id: 1},
        {name: "最热", id: 2},

      ]
    }
  },
  props: {
    type: {
      type: String,
      default: 'video'
    }
  },
  computed: {},
  mounted() {
    switch (this.type) {
      case 'video':
        this.activeMenu = 0;
        this.menuList = [
          {name: "全部课程", id: 0},
          {name: "最新", id: 1},
          {name: "最热", id: 2},
        ]
        break;
      case 'live':
        this.menuList = [
          {name: "直播中", id: 1},
          {name: "即将直播", id: 2},
          {name: "直播回顾", id: 3},
        ]
        break;
      case 'column':
        this.activeMenu = 2;
        this.menuList = [
          {name: "课程专栏", id: 2},
          {name: "专家专栏", id: 1},
        ]
        break;
    }


    console.log("this.activeMenu >> ",this.activeMenu)
    console.log("this.menuList >> ",this.menuList)
  },
  methods: {
    menuBar(val) {

      this.activeMenu = val;
      this.$emit("menuBar", val)
    }

  },


}
</script>
<style scoped lang="scss">
.menu {
  display: flex;
  padding-top: 0.2rem;

  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 3px;

  div {
    flex: 1;
    font-size: 0.32rem;
    color: #999;
    text-align: center;
    position: relative;
    // background: red;
  }

  .activeMenu {
    font-size: 0.34rem;
    color: #333;

    .activeIcon {
      display: inline-block;
      width: 0.56rem;
      height: 0.06rem;
      background: #174ad0;
      position: absolute;
      bottom: -3px;
      left: 50%;
      margin-left: -0.28rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/menu.vue